import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { MyWorkRoutingModule } from './my-work-routing.module'
import { RoleModule } from '../role/role.module'
import { MemberModule } from '../member/member.module'
import { UserRoleModule } from '../role/user-role/user-role.module'
import { CommonModule } from '@angular/common'
import { EmployeeContractModule } from './employee-contract/employee-contract.module'
import { EmployeeBookingModule } from './employee-booking/employee-booking.module'
import { MyWorkIndexComponent } from './index/index.component'
import { SupervisorSkillModule } from './supervisor-skill/supervisor-skill.module'
import { SupervisorBookingModule } from './supervisor-booking/supervisor-booking.module'
import { MyWorkScheduleComponent } from './schedule/index.component'
import { CalendarCheckedDateModalComponent } from './schedule/calendar-checked-date-modal/show.component'
import { EmployeeContractManagerLinkModule } from './employee-contract-manager-link/employee-contract-manager-link.module'
import { TimeBlockModule } from '../time-block/time-block.module'

@NgModule({
    imports: [
        CommonModule,
        MyWorkRoutingModule,
        SharedModule,
        RoleModule,
        UserRoleModule,
        MemberModule,
        EmployeeContractModule,
        EmployeeBookingModule,
        SupervisorSkillModule,
        SupervisorBookingModule,
        EmployeeContractManagerLinkModule,
        TimeBlockModule
    ],
    declarations: [
        MyWorkIndexComponent,
        MyWorkScheduleComponent,
        CalendarCheckedDateModalComponent
    ],
    exports: [],
    providers: []
})
export class MyWorkModule {}
